import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk-experimental/scrolling';
import { DropdownModule } from 'mis-crystal-design-system/dropdown';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from 'mis-crystal-design-system/dropdown';

const _c0 = function (a0) { return { "height": a0 }; };
class PhoneInputComponent {
    constructor() {
        this.dropdownData = [];
        this.dropdownSelectedItem = { value: "", label: "" };
        this.inputPlaceholder = 'Enter';
        this.inputFormControl = new FormControl();
        this.onDropdownSelection = new EventEmitter();
        this.searchEnabled = false;
        this.inputType = "number";
        this.searchLabel = "Search Keyword";
    }
    ngOnInit() {
    }
    handleDropdownSelection(item) {
        this.onDropdownSelection.emit(item);
    }
}
PhoneInputComponent.ɵfac = function PhoneInputComponent_Factory(t) { return new (t || PhoneInputComponent)(); };
PhoneInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PhoneInputComponent, selectors: [["mis-phone-input"]], inputs: { dropdownData: "dropdownData", dropdownSelectedItem: "dropdownSelectedItem", inputPlaceholder: "inputPlaceholder", inputFormControl: "inputFormControl", searchEnabled: "searchEnabled", inputType: "inputType", searchLabel: "searchLabel", dropdownHeight: "dropdownHeight", dropdownWidth: "dropdownWidth", inputHeight: "inputHeight", label: "label", dropdownListWidth: "dropdownListWidth", dropdownListHeight: "dropdownListHeight" }, outputs: { onDropdownSelection: "onDropdownSelection" }, decls: 5, vars: 16, consts: [[1, "main-container-phone"], [3, "height", "dropdownListWidth", "dropdownListHeight", "width", "data", "selectedItem", "label", "searchEnabled", "multiLine", "searchLabel", "onChange"], [1, "details-field"], [1, "input-box"], [1, "black-text", 3, "ngStyle", "placeholder", "formControl", "type"]], template: function PhoneInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "mis-dropdown", 1);
        ɵngcc0.ɵɵlistener("onChange", function PhoneInputComponent_Template_mis_dropdown_onChange_1_listener($event) { return ctx.handleDropdownSelection($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "input", 4);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("height", ctx.dropdownHeight)("dropdownListWidth", ctx.dropdownListWidth)("dropdownListHeight", ctx.dropdownListHeight)("width", ctx.dropdownWidth)("data", ctx.dropdownData)("selectedItem", ctx.dropdownSelectedItem)("label", ctx.label)("searchEnabled", ctx.searchEnabled)("multiLine", false)("searchLabel", ctx.searchLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(14, _c0, ctx.inputHeight))("placeholder", ctx.inputPlaceholder)("formControl", ctx.inputFormControl)("type", ctx.inputType);
    } }, dependencies: [ɵngcc1.NgStyle, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc3.DropdownComponent], styles: [".main-container-phone[_ngcontent-%COMP%]{display:flex;border:1px solid #e0e0e0;border-radius:6px}.details-field[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;min-width:224px;margin-right:24px}.details-field[_ngcontent-%COMP%]   .input-box[_ngcontent-%COMP%]{width:100%}.details-field[_ngcontent-%COMP%]   .input-box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;height:32px}input[_ngcontent-%COMP%]{padding:10px 16px;border:none;outline:none;width:100%;height:auto;border-radius:6px}.black-text[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{color:#181f33;line-height:24px;font-size:16px}input[_ngcontent-%COMP%]::-webkit-inner-spin-button, input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.main-container-phone[_ngcontent-%COMP%]     .item{padding:8px!important}.main-container-phone[_ngcontent-%COMP%]     .dropdown{border:unset!important}"] });
PhoneInputComponent.ctorParameters = () => [];
PhoneInputComponent.propDecorators = {
    dropdownHeight: [{ type: Input }],
    dropdownWidth: [{ type: Input }],
    inputHeight: [{ type: Input }],
    dropdownData: [{ type: Input }],
    dropdownSelectedItem: [{ type: Input }],
    label: [{ type: Input }],
    inputPlaceholder: [{ type: Input }],
    inputFormControl: [{ type: Input }],
    onDropdownSelection: [{ type: Output }],
    dropdownListWidth: [{ type: Input }],
    dropdownListHeight: [{ type: Input }],
    searchEnabled: [{ type: Input }],
    inputType: [{ type: Input }],
    searchLabel: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneInputComponent, [{
        type: Component,
        args: [{ selector: "mis-phone-input", template: "<div class=\"main-container-phone\">\n  <mis-dropdown [height]=\"dropdownHeight\" [dropdownListWidth]=\"dropdownListWidth\"[dropdownListHeight]=\"dropdownListHeight\" [width]=\"dropdownWidth\" [data]=\"dropdownData\" [selectedItem]=\"dropdownSelectedItem\" [label]=\"label\" [searchEnabled]=\"searchEnabled\" [multiLine]=\"false\" (onChange)=\"handleDropdownSelection($event)\" [searchLabel]=\"searchLabel\"></mis-dropdown>\n  <div class=\"details-field\">\n    <div class=\"input-box\">\n      <input\n      [ngStyle]=\"{'height': inputHeight }\"\n        class=\"black-text\"\n        [placeholder]=\"inputPlaceholder\"\n        [formControl]=\"inputFormControl\" \n        [type]=\"inputType\"\n      />\n    </div>\n  </div>\n</div>\n", styles: [".main-container-phone{display:flex;border:1px solid #e0e0e0;border-radius:6px}.details-field label{display:inline-block;min-width:224px;margin-right:24px}.details-field .input-box{width:100%}.details-field .input-box input{width:100%;height:32px}input{padding:10px 16px;border:none;outline:none;width:100%;height:auto;border-radius:6px}.black-text,input{color:#181f33;line-height:24px;font-size:16px}input::-webkit-inner-spin-button,input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.main-container-phone ::ng-deep .item{padding:8px!important}.main-container-phone ::ng-deep .dropdown{border:unset!important}"] }]
    }], function () { return []; }, { dropdownData: [{
            type: Input
        }], dropdownSelectedItem: [{
            type: Input
        }], inputPlaceholder: [{
            type: Input
        }], inputFormControl: [{
            type: Input
        }], onDropdownSelection: [{
            type: Output
        }], searchEnabled: [{
            type: Input
        }], inputType: [{
            type: Input
        }], searchLabel: [{
            type: Input
        }], dropdownHeight: [{
            type: Input
        }], dropdownWidth: [{
            type: Input
        }], inputHeight: [{
            type: Input
        }], label: [{
            type: Input
        }], dropdownListWidth: [{
            type: Input
        }], dropdownListHeight: [{
            type: Input
        }] }); })();

class PhoneInputModule {
    static forRoot() {
        return { ngModule: PhoneInputModule, providers: [] };
    }
}
PhoneInputModule.ɵfac = function PhoneInputModule_Factory(t) { return new (t || PhoneInputModule)(); };
PhoneInputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PhoneInputModule });
PhoneInputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, ReactiveFormsModule, FormsModule, OverlayModule, ScrollingModule, DropdownModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneInputModule, [{
        type: NgModule,
        args: [{
                declarations: [PhoneInputComponent],
                imports: [CommonModule, ReactiveFormsModule, FormsModule, OverlayModule, ScrollingModule, DropdownModule],
                exports: [PhoneInputComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PhoneInputModule, { declarations: function () { return [PhoneInputComponent]; }, imports: function () { return [CommonModule, ReactiveFormsModule, FormsModule, OverlayModule, ScrollingModule, DropdownModule]; }, exports: function () { return [PhoneInputComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PhoneInputComponent, PhoneInputModule };

